<!-- 拣货 -->
<template>
  <div class="page-content">
    <c-header pageName="拣货"></c-header>
    <div class="nav-tool">
      <section :class="selectStatus===0?'activity':''" @click="statusChange(0)">待拣货</section>
      <section :class="selectStatus===1?'activity':''" @click="statusChange(1)">拣货中</section>
    </div>
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
      :offset="100"
    >
      <div class="receive-item flex" v-for="(item,index) in orderList" :key="index">
        <div class="item-content">
          <section>拣货单号 : {{item.sn}}</section>
          <section>拣货数量 : {{item.total}}</section>
          <section v-if="item.status === 0">拣货状态 :&nbsp;<span style="color: #dc6350">未拣货</span></section>
          <section v-if="item.status === 1">拣货状态 :&nbsp;<span style="color: #409EFF">拣货中</span></section>
          <section v-if="item.status === 2">拣货状态 :&nbsp;<span style="color: #67C23A">已拣货</span></section>
        </div>
        <div class="item-icon" @click="goPickingDetail(item.id,item.sn,item.carCode, item.status)">
          <i class="iconfont xiangyou"></i>
        </div>
      </div>
    </van-list>
  </div>
</template>

<script>
import Header from "../components/headerNav.vue";
export default {
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      loading: false,
      finished: true,
      selectStatus: 0, // 0 -- 待拣货  1-- 拣货中
      orderList: []
    };
  },
  components: {
    "c-header": Header
  },
  mounted() {
	  this.getPickingList();
  },
  methods: {
    // 状态切换
    statusChange(value) {
      if (value !== this.selectStatus) {
        this.selectStatus = value;
        this.currentPage = 1;
        this.orderList = [];
        this.getPickingList();
      }
    },
    // 获取入库单列表
    getPickingList() {
      let param = {
        pageSize: this.pageSize,
        pageNumber: this.currentPage,
        status: this.selectStatus
      };
      this.$post(this.URL.getPickingList, param).then(res => {
        if (res.success) {
          this.totalCount = res.data.totalCount;
          this.orderList = [...this.orderList, ...res.data.records];
          if (res.data.totalPage > this.currentPage) {
            this.finished = false;
          } else {
            this.finished = true;
          }
        } else {
          this.$toast.fail(res.message);
        }
        this.loading = false;
      });
    },
    // 加载更多
    onLoad() {
      if (!this.finished) {
        this.currentPage++;
        this.getPickingList();
      }
	},
	// 拣货详情
	goPickingDetail(id,sn,carCode, status){
		this.$router.push({path:"/pickingDetail",query:{"pickingId":id,"pickOrderSn":sn,"pickCarCode": carCode, "status": status}});
	}
  }
};
</script>
<style lang='scss' scoped>
.nav-tool {
  display: flex;
  width: 100%;
  height: 3rem;
  background-color: #dc6350;
  padding: 0 3rem;
  align-items: center;
  justify-content: center;
  section {
    display: inline-flex;
    width: 7rem;
    justify-content: center;
    border: 1px solid #fff;
    height: 1.8rem;
    align-items: center;
    font-size: 0.9rem;
    color: white;
  }
  .activity {
    background-color: white;
    color: #dc6350;
  }

  section:first-child {
    border-top-left-radius: 0.2rem;
    border-bottom-left-radius: 0.2rem;
  }
  section:last-child {
    border-top-right-radius: 0.2rem;
    border-bottom-right-radius: 0.2rem;
  }
}
.van-list {
    display: flex;
    width: 100%;
    flex-wrap: wrap;
    padding: 1rem 0.5rem;
    font-size: 0.85rem;
    padding: 0.5rem 0.8rem;
    color: #444;
    .receive-item {
        padding: 0.5rem 0;
        border-bottom: 1px dashed #eee;
        .item-content {
            display: inline-flex;
            width: 90%;
            flex-wrap: wrap;
            section {
                display: flex;
                width: 100%;
                line-height: 1.2rem;
            }
        }
        .item-icon {
            display: inline-flex;
            width: 10%;
            align-items: center;
            justify-content: flex-end;
            i {
                font-size: 1.5rem;
                color: #dc6350;
            }
        }
    }
    >>> .van-list__loading {
        display: flex;
        width: 100%;
        justify-content: center;
    }
    >>> .van-list__finished-text {
        display: flex;
        width: 100%;
        justify-content: center;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/Picking.vue